import { assign } from 'lodash';

// defalt animation settings
const DEFAULT_SETTINGS = {
    distance: 10, // 10px
    reverse: true,
    duration: 0.5,
    delay: 0,
    staggered: false,
};

// fade and slide animation config function
export const fadeInSlideY = _settings => {

    // generate final animation settings
    const settings = assign( {}, DEFAULT_SETTINGS, _settings );

    // variants
    const variants = {
        initial: {
            opacity: 0,
            y: settings.distance,
        },
        enter: {
            opacity: 1.1,
            y: 0,
            transition: {
                duration: settings.duration,
                ease: [ .28, .57, .45, 1.22 ], // spring
            },
        },
        exit: {
            opacity: 0,
            y: settings.distance,
            transition: { duration: settings.duration },
        },
    };

    return {
        variants,
        initial: 'initial',
        ...(
            settings.staggered ? {} : {
				animate: 'enter',
				exit: 'exit',
            }
        )
    };
};
